import { alpha } from '@mui/material';
import React, { ReactNode } from 'react';
import { bluePlanetTheme } from 'ui/theme';
import styled from '@emotion/styled';
import { contentSpacing, halfSpacing, quarterSpacing } from 'ui/theme/themeConstants';
import FontRedHat from 'ui/theme/FontRedHat';
import Card, { BackgroundColor, getTextColor } from './Card';

interface Props {
  title: string | React.ReactNode;
  subTitle?: React.ReactNode;
  children?: ReactNode;
  className?: string;
  color?: BackgroundColor;
}

const StyledCard = styled(Card)`
  font-weight: ${bluePlanetTheme.typography.fontWeightMedium};
  padding: ${halfSpacing} ${contentSpacing};
  font-family: ${FontRedHat.display};
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${contentSpacing};
`;

const StyledBody = styled.div`
  ${bluePlanetTheme.breakpoints.down('sm')} {
    display: flex;
    flex-direction: column;
  }
`;
const Divider = styled.span`
  margin: 0 ${quarterSpacing};
  ${bluePlanetTheme.breakpoints.down('sm')} {
    display: none;
  }
`;

export default function CardInfoCard(props: Props) {
  const color = props.color ?? 'orange';
  return (
    <StyledCard padding="half" className={props.className} color={color}>
      <StyledBody>
        {props.title}
        {props.subTitle && (
          <span
            className="text-small"
            style={{
              color: alpha(getTextColor(color), 0.7),
            }}
          >
            <Divider>-</Divider>
            {props.subTitle}
          </span>
        )}
      </StyledBody>
      {props.children}
    </StyledCard>
  );
}
